// HIPAAtizer routing policy for every patient-facing form on the site.
//
// REQUIRE_HIPAATIZER = true means: a form slot ("placement") only submits when a
// published HIPAAtizer form is configured for it in /admin/hipaatizer. Until
// then the slot shows a call/text fallback instead of the native form, so no
// patient data can be submitted to this site's own backend or to a third party.
// Flip to false to let native forms run again while a slot is unconfigured.
export const REQUIRE_HIPAATIZER = true;

// Every patient-facing form slot on the site. Adding a slot here makes it
// selectable in /admin/hipaatizer; the HipaatizerForm entity enum must match.
export const PLACEMENTS = [
  { value: 'consult-request', label: 'Signature Consultation request (/consult)' },
  { value: 'implant-assessment', label: 'Dental implants assessment survey (/implants-assessment)' },
  { value: 'text-us', label: '"Send us a text" widget (site-wide)' },
  { value: 'contact', label: 'Contact form' },
  { value: 'patient-intake', label: 'Patient intake / new patient forms' },
];

export const PLACEMENT_LABELS = Object.fromEntries(PLACEMENTS.map((p) => [p.value, p.label]));

// Origins HIPAAtizer serves published forms and embed scripts from.
// Mirrored in index.html (Content-Security-Policy) and Layout.jsx.
export const HIPAATIZER_ORIGINS = ['https://app.hipaatizer.com'];

export const FALLBACK_CONTACT = {
  phone: '(727) 228-6846',
  phoneHref: 'tel:+17272286846',
  sms: '(727) 607-8699',
  smsHref: 'sms:7276078699',
};
